/**
 * O número de avisos não lidos ao lado de "Avisos" no menu (E150.F1 — GUS-150). Sem número quando
 * não há o que ler ou quando a leitura falhou. O texto para leitor de tela diz o que o número é.
 */
export function ContadorDeAvisos({
  naoLidos,
  rotulo,
}: {
  naoLidos: number | null;
  rotulo: string;
}) {
  if (naoLidos === null || naoLidos === 0) return null;
  return (
    <span
      data-testid="menu-avisos-nao-lidos"
      className="ml-auto min-w-[20px] bg-accent-600 px-1.5 py-px text-center font-mono text-[11px] font-semibold text-fg-onInverse"
    >
      <span aria-hidden="true">{naoLidos}</span>
      <span className="sr-only">{rotulo.replace('{n}', String(naoLidos))}</span>
    </span>
  );
}
